const nepalRatings = [
    {
        "name": "John",
        "rating": 4,
        "review": "My experience in Nepal was truly unforgettable. The majestic mountains, vibrant culture, and warm hospitality of the locals left a lasting impression on me. Trekking through the Himalayas was a dream come true, and I can't wait to visit again!",
        "image": "assets/user.avif",
        "date": "2024-01-15"
      },
      {
        "name": "Emma",
        "rating": 5,
        "review": "Nepal exceeded all my expectations! The natural beauty of this country is unparalleled, with stunning landscapes at every turn. The people are incredibly friendly and welcoming, making me feel at home from the moment I arrived. I highly recommend Nepal to anyone seeking adventure and cultural immersion.",
        "image": "assets/user.avif",
        "date": "2024-01-20"
      },
      {
        "name": "Michael",
        "rating": 3,
        "review": "While Nepal offers breathtaking scenery and rich cultural experiences, I found that the infrastructure in some areas could be improved. Transportation and accommodation options were limited in certain regions, making it challenging to explore remote areas.",
        "image": "assets/user.avif",
        "date": "2024-02-05"
      },
      {
        "name": "Sophia",
        "rating": 5,
        "review": "Visiting Nepal was a life-changing experience for me. The warmth and hospitality of the Nepalese people touched my heart, and I felt a deep connection to the land and its traditions. From exploring ancient temples to trekking through remote villages, every moment was filled with wonder and discovery. I can't wait to return and continue exploring this beautiful country!",
        "image": "assets/user.avif",
        "date": "2024-02-10"
      },
      {
        "name": "William",
        "rating": 4,
        "review": "My trip to Nepal was nothing short of amazing. The diverse landscapes, from lush valleys to snow-capped peaks, provided endless opportunities for adventure. I particularly enjoyed trekking in the Annapurna region, where I was surrounded by breathtaking scenery at every step. The local cuisine was also a highlight, with delicious flavors and unique dishes to try. Overall, Nepal left a lasting impression on me, and I can't wait to come back for more!",
        "image": "assets/user.avif",
        "date": "2024-02-20"
      },
      
        {
        "name": "Oliver",
        "rating": 4,
        "review": "My journey to Nepal was an incredible adventure! The natural beauty of the country, from the lush forests to the towering mountains, left me in awe. Trekking in the Annapurna Sanctuary was challenging but rewarding, with stunning views and a sense of accomplishment at every turn. The people of Nepal were incredibly welcoming, and I enjoyed learning about their rich culture and traditions. Nepal has a special place in my heart, and I hope to return soon!",
        "image": "assets/user.avif",
        "date": "2024-03-15"
        }
  ];
  
  export default nepalRatings;
  